/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Since_In_FutureInputs */

const en_us2_injury_since_in_future = /** @type {(inputs: Injury_Since_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pain cannot have started after today.`)
};

const pt_br2_injury_since_in_future = /** @type {(inputs: Injury_Since_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma dor não pode ter começado depois de hoje.`)
};

const es_419_injury_since_in_future = /** @type {(inputs: Injury_Since_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un dolor no puede haber empezado después de hoy.`)
};

const pt_pt2_injury_since_in_future = /** @type {(inputs: Injury_Since_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma dor não pode ter começado depois de hoje.`)
};

const fr_fr2_injury_since_in_future = /** @type {(inputs: Injury_Since_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une douleur ne peut pas avoir commencé après aujourd'hui.`)
};

const de_de2_injury_since_in_future = /** @type {(inputs: Injury_Since_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Schmerz kann nicht nach heute begonnen haben.`)
};

const it_it2_injury_since_in_future = /** @type {(inputs: Injury_Since_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un dolore non può essere iniziato dopo oggi.`)
};

/**
* | output |
* | --- |
* | "A pain cannot have started after today." |
*
* @param {Injury_Since_In_FutureInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const injury_since_in_future = /** @type {((inputs?: Injury_Since_In_FutureInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Since_In_FutureInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_injury_since_in_future(inputs)
	if (locale === "es-419") return es_419_injury_since_in_future(inputs)
	if (locale === "pt-PT") return pt_pt2_injury_since_in_future(inputs)
	if (locale === "fr-FR") return fr_fr2_injury_since_in_future(inputs)
	if (locale === "de-DE") return de_de2_injury_since_in_future(inputs)
	if (locale === "it-IT") return it_it2_injury_since_in_future(inputs)
	return en_us2_injury_since_in_future(inputs)
});
export { injury_since_in_future as "injury.since_in_future" }